import { z } from 'zod'

export const batchDeleteExpensesSchema = z.object({
  ids: z.array(z.string().guid()).min(1).max(500),
  skipBalanceUpdate: z.boolean().optional().default(false),
})

export type BatchDeleteExpensesDto = z.infer<typeof batchDeleteExpensesSchema>
